import { useState, useCallback } from 'react';

/**
 * Custom hook to manage channel modal states
 * @returns {Object} Modal states and handlers
 */
const useChannelModals = () => {
    const [showAddModal, setShowAddModal] = useState(false);
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [selectedChannel, setSelectedChannel] = useState(null);

    const handleShowAdd = useCallback(() => {
        setShowAddModal(true);
        setSelectedChannel(null);
    }, []);

    const handleShowDetails = useCallback((channel) => {
        setSelectedChannel(channel);
        setShowDetailsModal(true);
    }, []);

    const handleCloseModals = useCallback(() => {
        setShowAddModal(false);
        setShowDetailsModal(false);
        setSelectedChannel(null);
    }, []);

    return {
        showAddModal,
        showDetailsModal,
        selectedChannel,
        handleShowAdd,
        handleShowDetails,
        handleCloseModals,
    };
};

export default useChannelModals;
